import { __awaiter } from "tslib";
import { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getCustomerDetailsValidationSchema } from '../../form/registration-fields/CustomerDetailsFields.utils';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useDeliveryState } from '../../../context/CheckoutDeliveryContext';
export const useValidateCustomerDetails = () => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.general]);
    const customerValues = useFormContext().getValues('customer');
    const [showCustomerDetailsForm, setShowCustomerDetailsForm] = useState(!!customerValues);
    const shouldValidate = useRef(true);
    const [{ activeDeliveryOption }] = useDeliveryState();
    useEffect(() => {
        shouldValidate.current = true;
    }, [activeDeliveryOption]);
    useEffect(() => {
        const validateForm = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!customerValues || !Object.keys(customerValues).length) {
                return;
            }
            const isValid = yield getCustomerDetailsValidationSchema({ t }).isValid(customerValues);
            setShowCustomerDetailsForm(!isValid);
            shouldValidate.current = false;
        });
        shouldValidate.current && !showCustomerDetailsForm && validateForm();
    }, [customerValues, activeDeliveryOption]);
    const handleEdit = () => {
        setShowCustomerDetailsForm(true);
        shouldValidate.current = false;
    };
    return {
        showCustomerDetailsForm,
        handleEdit,
    };
};
